import React, { useState } from 'react'
import { CustomModal } from '../CustomModal/CustomModal'
import { t } from 'i18next';
import { ButtonWhite } from '../Buttons/ButtonWhite';
import { ButtonWhiteTwo } from '../Buttons/ButtonWhiteTwo';
import { CustomDateInput } from '../CustomDateInput/CustomDateInput';

const DateAndTimeFormModal = ({ showModal, setShowModal, initialStateDates, addDates, isAccess }) => {

    const [dates, setDates] = useState(initialStateDates);

    const {
        accessDate: initialAccessDate,
        accessHour: initialAccessHour,
        exitDate: initialExitDate,
        exitHour: initialExitHour
    } = initialStateDates;

    const { accessDate, accessHour, exitDate, exitHour } = dates;

    const handleChange = (value, name) => {
        setDates({
            ...dates,
            [name]: value
        })
    }

    const handleSubmitDates = () => {
        setShowModal();
        addDates(dates)
    }

    const handleClose = () => {
        setShowModal();
    }

    const disabled = () => {
        if (isAccess) {
            return !!!accessDate.trim() || !!!accessHour || (new Date(`${accessDate}T${accessHour}:00`).getTime() > new Date(`${initialAccessDate}T${initialAccessHour}:00`).getTime())
        } else {
            return !!!exitDate.trim() || !!!exitHour || (new Date(`${exitDate}T${exitHour}:00`).getTime() <= new Date(`${accessDate}T${accessHour}:00`).getTime()) || (new Date(`${exitDate}T${exitHour}:00`).getTime() > new Date(`${initialExitDate}T${initialExitHour}:00`).getTime())
        }
    }

    return (
        <CustomModal
            showModal={showModal}
            setShowModal={setShowModal}
            title={isAccess ? t('DATE_HOUR_ENTRY') : t('DATE_HOUR_EXIT')}
            centered
        >
            <div className='mb-4'>
                <div className='mb-3'>
                    <label
                        className='form-label'
                        style={{ color: '#809FB8' }}
                        htmlFor={isAccess ? "accessDate" : "exitDate"}
                    >
                        {t('DATE')}
                    </label>
                    <CustomDateInput
                        name={isAccess ? "accessDate" : "exitDate"}
                        value={isAccess ? accessDate : exitDate}
                        onChange={(value) => handleChange(value, isAccess ? "accessDate" : "exitDate")}
                    />
                </div>
                <div>
                    <label
                        className='form-label'
                        style={{ color: '#809FB8' }}
                        htmlFor={isAccess ? "accessHour" : "exitHour"}
                    >
                        {t('HOUR')}
                    </label>
                    <input
                        type="time"
                        className="form-control"
                        name={isAccess ? "accessHour" : "exitHour"}
                        onChange={(e) => handleChange(e.target.value, e.target.name)}
                        value={isAccess ? accessHour : exitHour}
                    />
                </div>
            </div>
            <div className='d-flex text-center'>
                <ButtonWhite onClick={handleClose}>
                    {t('CANCEL')}
                </ButtonWhite>
                <ButtonWhiteTwo onClick={handleSubmitDates} disabled={disabled()}>
                    {t('SAVE')}
                </ButtonWhiteTwo>
            </div>
        </CustomModal>
    )
}

export default DateAndTimeFormModal